import { selectAppEnv } from '@trifence/utilities';

export const title = selectAppEnv([
  'CompanyON',
  'CompanyON — Staging',
  'CompanyON — Dev',
]);
